import { createWebHistory, createRouter } from "vue-router";
import FormSection from "@/components/FormSection.vue";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import ConfirmacionSection from "@/components/ConfirmacionSection.vue";


const routes = [
  {
    path: "/",
    component: FormSection,
  },
  {
    path: "/:hash",
    component: ConfirmacionSection,
  },
  {
    path: "/noconfirma/:hash",
    component: NoConfirmacionSection,
  },
  {
    path: "/preevento/:hash",
    component: PreEventoSection,
  },
  {
    path: "/adicional/:hash",
    component: AdicionalSection,
  },
  {
    path: "/finalizado",
    name: "Finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/credencial",
    name: "Credencial",
    component: CredencialSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

import AdicionalSection from "@/components/AdicionalSection.vue";
import NoConfirmacionSection from "@/components/NoConfirmacionSection.vue";
import PreEventoSection from "@/components/PreEventoSection.vue";
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;